import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import WmsDesktopLayout from "../../wmsDesktopLayout";
import {FormattedMessage} from "react-intl";
import PageTitle from "../../../../components/WMS/Mobile/PageTitle";
import {Card, CardContent, Grid} from "@mui/material";
import CustomCheckbox from "../../../../components/checkbox/CustomCheckbox";
import CreatePickingMissionForm from "../components/CreatePickingMissionForm";
import {PickingMissionModelContext} from "../PickingMissionModelContext";

function CreatePickingMissionDesktopContainer() {
    const {
        isEdit,
        isModelAuto,
        isModel,
        setIsModel,
        setIsModelAuto,
    } = useContext(PickingMissionModelContext)

    const handleIsModel = () => {
        setIsModel(prev => !prev)
    }

    const handleIsModelAuto = () => {
        setIsModelAuto(prev => !prev)
    }
    return (
        <WmsDesktopLayout>
            <WmsDesktopLayout.Content>
                <Card>
                    <CardContent>
                        <Grid container gap={"48px"}>
                            <PageTitle
                                isDesktop={true}
                                title={<FormattedMessage id={"wms.newPickingMission.title"}/>}
                                subtitle={<FormattedMessage id={"wms.newPickingMission.subtitle"}/>}
                            />
                            <Grid container gap={"8px"} alignContent={"center"} onClick={isEdit ? () => {} : handleIsModel}>
                                <CustomCheckbox disabled={isEdit} checked={isModel}/>
                                <span style={{fontSize: "14px", height: "fit-content", margin:"auto 0"}}>
                                    <FormattedMessage id={"wms.newPickingMission.checkbox.label"}/>
                                </span>
                            </Grid>

                            {isModel && (
                                <Grid container gap={"8px"} alignContent={"center"} onClick={handleIsModelAuto}>
                                    <CustomCheckbox checked={isModelAuto}/>
                                    <span style={{fontSize: "14px", height: "fit-content", margin:"auto 0"}}>
                                <FormattedMessage id={"wms.newPickingMission.isAuto.checkbox.label"}/>
                            </span>
                                </Grid>
                            )}

                            <CreatePickingMissionForm />
                        </Grid>
                    </CardContent>
                </Card>
            </WmsDesktopLayout.Content>
        </WmsDesktopLayout>
    );
}

export default CreatePickingMissionDesktopContainer;